import { productsState } from '@/states/products.state';
import { atom } from 'jotai';

/**
 * Au moins une ligne du deal a un prix remisé strictement positif
 * (après normalisation UI dans useDealItems).
 */
export const hasDiscountedPriceOnDealAtom = atom((get) => {
  const products = get(productsState);
  return products.some(
    (p) =>
      typeof p.activeVersion.discountedPrice === 'number' &&
      p.activeVersion.discountedPrice > 0
  );
});
